module.exports = __webpack_public_path__ + "img/jackpot-moonbg.5056fcd.webp";